export default "assets/images/icons/wine-accords-36529ebd.svg";